<iframe [src]="iframe_src | safeURL" style="display:none"></iframe>